import DocumentTextIcon from '@heroicons/react/outline/DocumentTextIcon';
import { useSearch } from '@tribeplatform/react-sdk/hooks';
import { getSearchKey } from '@tribeplatform/react-sdk/utils/keys';
import { useDebounce } from '../../common/hooks/useDebounce';
import { useI18n } from '../../i18n';
import { getSearchItemLink } from '../../Search';
import { cleanSearchQuery } from '../../utils/search';
import { emptyCommandBarResult } from '../types';
export const useCommandBarSearch = ({ query: dirtyQuery, }) => {
    var _a, _b;
    const intl = useI18n();
    const query = cleanSearchQuery(dirtyQuery);
    const debouncedQuery = useDebounce(query, 100);
    const generatedQuery = `${debouncedQuery} +for:post`;
    const { data: searchData, isLoading } = useSearch({
        variables: {
            input: {
                query: debouncedQuery ? generatedQuery : null,
            },
        },
        fields: { in: 'basic' },
        useQueryOptions: {
            queryKey: getSearchKey({
                variables: {
                    input: { query: debouncedQuery ? generatedQuery : null },
                },
            }),
            keepPreviousData: true,
            enabled: (query === null || query === void 0 ? void 0 : query.length) > 1,
        },
    });
    if (!query)
        return emptyCommandBarResult;
    const posts = ((_b = (_a = searchData === null || searchData === void 0 ? void 0 : searchData.hits) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.hits) || [];
    if (!(posts === null || posts === void 0 ? void 0 : posts.length))
        return emptyCommandBarResult;
    const categoryTexts = {
        search: intl.$t({
            id: 'Generics.Search',
            defaultMessage: 'Search',
        }),
    };
    return {
        isLoading,
        actions: (posts === null || posts === void 0 ? void 0 : posts.map(post => {
            return {
                name: post.title,
                url: getSearchItemLink(post),
                icon: DocumentTextIcon,
                category: categoryTexts.search,
            };
        })) || [],
    };
};
//# sourceMappingURL=useCommandBarSearch.js.map